import { Modal, Table } from "components";
import { useEffect, useState, useCallback, useRef } from "react";
import { StoresPopup } from "popups/Stores/Stores";
import { getRowIds } from "helpers/data/dataHandling";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { RootState } from "redux/store";
import { getStores } from "redux/slices/Stores";
import { updatePreferredBrandField, getPreferredBrandDetails, addAGGriSelectedStoresRows } from "redux/slices/PreferredBrands";
import BaseCellRenderer from "components/AgGrid/CellRenderers/BaseCellRenderer";
import { AgGridReact } from "ag-grid-react";
import { getPreferredBrandsStoresConfig } from "TableConfigs/PreferredBrandsStoresConfig";
import { AgGridToolbar } from "components/AgGrid/AgGridToolbar";
import { Z } from "models/common/components";
import { ZTooltip } from "components/ZTooltip";
import { ZIconType } from "helpers/utility/iconMap";

export function Stores() {
    const dispatch = useAppDispatch();
    const [showPopup, setShowPopup] = useState(false);
    const [canReloadStores, setCanReloadStores] = useState(true);
    const stores = useAppSelector((state: RootState) => state.stores);
    const preferredBrands: any = useAppSelector((state: RootState) => state.preferredBrands);
    const currentStoreGroupId = useAppSelector((state: RootState) => state.global.storeGroupId);
    const preferredBrandsStoresGridRef = useRef<AgGridReact>(null);
    const [showDelete, setShowDelete] = useState<boolean>(false);   

    useEffect(() => {
        canReloadStores && getStoresTable();
    }, [preferredBrands.stores, preferredBrands.storesList]);

    function getStoresTable() {
        let storeList: any[] = [...preferredBrands.stores];
        preferredBrands.storesList.map((store: any) => {
            if (!storeList.includes(store)) storeList.push(store);
        });
        let storesTable: any[] = [];
        dispatch(getStores({ storeGroupIds: [currentStoreGroupId] })).then((res) => {
            res.data.map((store: any) => {
                if (storeList.includes(store.id as never)) storesTable.push(store);
            });
            dispatch(updatePreferredBrandField({ key: "storesTable", value: storesTable }));
        });
    }

    async function storesPopupSave() {
        let selectedStores: any[] = [];
        let deseledStores: any[] = [];
        let storeList: any[] = [...preferredBrands.stores];
        let selectedStoresIds: any[] = [];
        selectedStores = getRowIds(stores.selectedRows);
        deseledStores = getRowIds(stores.deselectedRows);
        if (stores.selectAllFilter) {
            await dispatch(getStores({ storeGroupIds: [currentStoreGroupId] })).then(async (res) => {
                const storeIds = res.data.map((i: any) => i.id);
                await storeIds.forEach((store: number) => {
                    if (!deseledStores.includes(store)) selectedStoresIds.push(store);
                });
            });
        } else {
            selectedStores.forEach(async (store: number) => selectedStoresIds.push(store));
        }
        selectedStoresIds.forEach((store: number) => {
            if (!storeList.includes(store)) storeList.push(store);
        });
        dispatch(updatePreferredBrandField({ key: "storesList", value: storeList }));
        setShowPopup(false);
    }

    async function handleDelete() {
        setCanReloadStores(false);
        let storesList: any[] = [];
        preferredBrands.storesTable.map((store: any) => {
            if (!preferredBrands.selectedStoresRows.includes(store.id)) 
                storesList.push(store);
        });
        var a = preferredBrands.storesList;
       // await dispatch(updatePreferredBrandField({ key: "storesList", value: storesList }));
        await dispatch(updatePreferredBrandField({ key: "stores", value: storesList.map((x)=> x.id) }));
        await dispatch(updatePreferredBrandField({ key: "storesTable", value: preferredBrands.storesTable.filter((st: any) => !preferredBrands.selectedStoresRows.includes(st.id)) }));
        setCanReloadStores(true);
    }

    return (
        <>
            <StoresPopup show={showPopup} onClose={() => setShowPopup(false)} onSave={storesPopupSave} />
             <AgGridToolbar
                    search={true}
                    className="pb-1"
                    handleSubmit={(searchState, filterState) => {
                        preferredBrandsStoresGridRef.current?.api.clearRangeSelection();
                        dispatch(addAGGriSelectedStoresRows([]));
                        preferredBrandsStoresGridRef.current?.api.setGridOption('quickFilterText', searchState?.keyword);                                            
                    }}
                    searchProps={
                        {totalRows: preferredBrands.storesTable.length, placeholder: "by Name", hideContains: true}
                    }
                    children={(
                        <div className="d-inline-flex gap-1">
                            { 
                            (preferredBrands.selectedStoresRows != undefined && preferredBrands.selectedStoresRows.length != 0) &&									
                                <Z.Button variant="light" className="h-100" disabled={true} buttonText={preferredBrands.selectedStoresRows.length+ " Selected"}/>
                            }
                                <ZTooltip text="Add">
                                <Z.Button icon={ZIconType.Add} buttonSize="md" onClick={() => setShowPopup(true)}/>
                                </ZTooltip>
                            <ZTooltip text={
                                preferredBrands.selectedStoresRows.length == 0? `Please select a row to delete`:
                                preferredBrands.selectedStoresRows.length == preferredBrands.pbsManufacturers.length ? `Delete all rows`:									  
                                preferredBrands.selectedStoresRows.length> 0 ? `Delete ${preferredBrands.selectedStoresRows.length} rows` :                                                    
                                "Please select a row to delete"}>
                                <Z.Button icon={ZIconType.Delete} buttonSize="md"  onClick={() => setShowDelete(true)} 
                                    disabled={preferredBrands.selectedStoresRows.length < 1} />
                            </ZTooltip>
                            <ZTooltip text="Refresh">
                                <Z.Button icon={ZIconType.Refresh} buttonSize="md" onClick={() => 
                                    dispatch(getPreferredBrandDetails({ ids: [preferredBrands.id], loadDetails: ['Manufacturers', 'Stock', 'Stores']  })).then((res) => {
                                        if(res.totalRows == 0){
                                            preferredBrandsStoresGridRef.current?.api.showNoRowsOverlay()
                                        }
                                    })} 
                                />
                            </ZTooltip>
                        </div>
                    )}
                />
            <AgGridReact
                ref={preferredBrandsStoresGridRef}
                columnDefs={getPreferredBrandsStoresConfig(preferredBrands.stores)}
                rowData={preferredBrands.storesTable}
                pagination={true}
                paginationPageSize={20}
                className="ag-theme-quartz ag-theme-custom w-100"
                containerStyle={{ height: "65dvh" }}
                rowSelection="multiple"
                suppressRowClickSelection={true}
                suppressCellFocus={true}
                suppressContextMenu
                onSelectionChanged={(e) => {
                    dispatch(addAGGriSelectedStoresRows(e.api.getSelectedRows().map((xe: any) =>  xe.id)));
                }}
                onRowSelected={(e) => {
                    dispatch(addAGGriSelectedStoresRows(e.api.getSelectedRows().map((xe: any) =>  xe.id)));
                }}
                components={{
                    baseCellRenderer: BaseCellRenderer,
                }}
            />
             <Modal
                title="Confirm Delete"
                show={showDelete}
                buttonType="primary"
                buttonText={"Continue"}
                buttonCloseText="Cancel"
                handleSubmit={() => {
                    handleDelete();
                    setShowDelete(false);
                    preferredBrandsStoresGridRef.current?.api.deselectAll();

                }}
                handleClose={() => setShowDelete(false)}
                description={
                    <>
                        <p>You are about to delete {preferredBrands.selectedStoresRows.length} selected {preferredBrands.selectedStoresRows.length > 1 ? "items": "item"}.</p>
                        <p>Are you sure you want to delete?</p>
                    </>
                }
            />
        </>
    );
}